import React from 'react';
import '../guide/Guide.css';
import './GuideContact.css';
import { trackEvent } from '../../utils/analytics';
import TryFreeBtn from '../../components/TryFreeBtn';
import useContactForm from '../../hooks/useContactForm';

const EMPTY = { name: '', restaurant: '', email: '', phone: '', question: '' };

const GuideContact = () => {
  const { formData, submitted, setSubmitted, loading, error, handleChange, handleSubmit } = useContactForm(EMPTY, {
    notifySource: 'guide-download',
    onSuccess: () => trackEvent('Form', 'submit', 'Guide Download Form'),
  });

  return (
    <div className="guide-page">
      <div
        className="guide-header"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/horizontal_background.png)` }}
      >
        <div className="container">
          <div className="guide-header-inner">
            <h1>Get Started with OW Restaurant Owner App</h1>
            <p>Book More info to know how it works, and receive App</p>
          </div>
        </div>
      </div>

      <section className="guide-contact-section">
        <div className="container">
          <div className="guide-contact-box">
            {submitted ? (
              <div className="guide-success">
                <div className="success-icon">✓</div>
                <h3>You're In! 🚀</h3>
                <p>Soon we will sent you everything you need to install and set up the OW Owner App.</p>
                <p className="gd-success-sub">Can't wait to see your Restaurant 🎉</p>
                <button onClick={() => setSubmitted(false)} className="btn btn-back">Submit Another</button>
              </div>
            ) : (
              <>
                {error && (
                  <div className="error-message">
                    <div className="error-icon">⚠️</div>
                    <p>{error}</p>
                  </div>
                )}
                <form
                  onSubmit={(e) => handleSubmit(e, {
                    email: formData.email,
                    message:
                      `New Owner App request:\n` +
                      `Name: ${formData.name}\n` +
                      `Restaurant: ${formData.restaurant}\n` +
                      `Phone: ${formData.phone || 'empty'}\n` +
                      `Description: ${formData.question || 'empty'}`,
                  })}
                  className="guide-contact-form"
                >
                  <div className="form-group">
                    <label htmlFor="gd-name">Your Name *</label>
                    <input type="text" id="gd-name" name="name" value={formData.name}
                      onChange={handleChange} required placeholder="John Doe" disabled={loading} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="gd-restaurant">Restaurant Name *</label>
                    <input type="text" id="gd-restaurant" name="restaurant" value={formData.restaurant}
                      onChange={handleChange} required placeholder="My Restaurant" disabled={loading} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="gd-email">Email *</label>
                    <input type="email" id="gd-email" name="email" value={formData.email}
                      onChange={handleChange} required placeholder="your.email@example.com" disabled={loading} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="gd-phone">Phone Number <span className="optional-label">(optional)</span></label>
                    <input type="tel" id="gd-phone" name="phone" value={formData.phone}
                      onChange={handleChange} placeholder="+357 99 000 000" disabled={loading} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="gd-question">Question <span className="optional-label">(optional)</span></label>
                    <textarea id="gd-question" name="question" value={formData.question}
                      onChange={handleChange} rows="3" placeholder="Any questions or comments..." disabled={loading} />
                  </div>


                  <div className="gd-submit-row">
                    <TryFreeBtn asSubmit disabled={loading} text="Book More Info" />
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default GuideContact;
